// features.js
export const FEATURES = [
  { key: 'introLabs', label: 'Intro & awareness labs' },
  { key: 'basicSim', label: 'Basic attack & defense simulations' },
  { key: 'community', label: 'Community forum access' },
  { key: 'runtime', label: 'Extended lab runtime' },
  { key: 'paths', label: 'Structured learning paths' },
  { key: 'walkthroughs', label: 'Guided walkthroughs' },
  { key: 'tracking', label: 'Progress & skill tracking' },
  { key: 'certs', label: 'Certificates of completion' },
  { key: 'advancedLabs', label: 'Advanced real-world labs' },
  { key: 'blueRed', label: 'Blue & Red team simulations' },
  { key: 'irForensics', label: 'Incident response & forensics labs' },
  { key: 'badges', label: 'Skill-based badges & assessments' },
  { key: 'prioritySupport', label: 'Priority support' },
  { key: 'earlyAccess', label: 'Early access to new labs' },
];
